import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { getIconPath } from '@tcp/core/src/utils';
import DetailedEarnExtraPointsTile from '../../../molecule/DetailedEarnExtraPointsTile';
import withStyles from '../../../../../../common/hoc/withStyles';
import Anchor from '../../../../../../common/atoms/Anchor';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import Row from '../../../../../../common/atoms/Row';
import Image from '../../../../../../common/atoms/Image';
import styles from '../styles/EarnExtraPointsTileNew.style';
import internalEndpoints from '../../../internalEndpoints';
import EarnExtraPointsTileSkeleton from '../skeleton/EarnExtraPointsTileSkeleton.view';
import ExtraPointsDetailModal from '../../../../ExtraPoints/organism/ExtraPointsDetailModal.view';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import AccountCommonLabels, {
  ACCOUNT_LABELS,
  GLOBAL_LABELS,
} from '../../../labels/AccountCommon.labels';

const EarnExtraPointsTileNew = ({
  className,
  waysToEarn,
  isFetching,
  isAccountDrawer,
  closedOverlay,
}) => {
  const accountLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, AccountCommonLabels);
  const globalLabels = getLabelFromCopyOrFromTranslation(GLOBAL_LABELS, AccountCommonLabels);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const onViewActivityDetails = (selectedItem) => {
    setSelectedActivity(selectedItem);
  };

  return (
    waysToEarn &&
    waysToEarn.length > 0 && (
      <div
        className={
          isAccountDrawer
            ? `${className} earn-extra-tile-wrapper-drawer`
            : `${className} earn-extra-tile-wrapper`
        }
      >
        {isAccountDrawer ? (
          <BodyCopy component="div" className="start-earn-points-heading">
            {renderLabel(
              globalLabels?.accountDrawer?.lbl_startEarningPoints_label,
              'lbl_startEarningPoints_label'
            )}
          </BodyCopy>
        ) : (
          <BodyCopy component="div" className="earn-tile-heading">
            <Image
              src={`${getIconPath('earning-points')}`}
              alt={'Earn Icon'}
              className="earn-extra-point-icon"
            />
            <span className="start-earning-points-text">
              {renderLabel(
                accountLabels?.common?.lbl_common_extraPointsHeading,
                'lbl_common_extraPointsHeading'
              )}
            </span>
            <Anchor
              to={internalEndpoints.extraPointsPage.link}
              asPath={internalEndpoints.extraPointsPage.path}
              className="earn-extra-view-all"
              target={'_self'}
              dataLocator={'accountverview-earnExtaPointTitle-viewallcta'}
            >
              {renderLabel(globalLabels?.cartItemTile?.lbl_view_all, 'lbl_view_all')}
            </Anchor>
          </BodyCopy>
        )}
        <Row fullBleed className="earn-tile-main">
          {isFetching ? (
            <EarnExtraPointsTileSkeleton />
          ) : (
            waysToEarn &&
            waysToEarn
              .filter((el, index) => index < 4)
              .map((item, index) => {
                return (
                  <DetailedEarnExtraPointsTile
                    isNewEarnExtraPoint
                    isAccountDrawer={isAccountDrawer}
                    key={index.toString()}
                    waysToEarnRow={item}
                    onViewActivityDetails={onViewActivityDetails}
                    viewAll
                  />
                );
              })
          )}
        </Row>
        <BodyCopy
          component="div"
          className={isAccountDrawer ? 'earn-extra-view-all-wrapper' : 'earn-extra-view-all-mobile'}
        >
          <Anchor
            to={internalEndpoints.extraPointsPage.link}
            asPath={internalEndpoints.extraPointsPage.path}
            className="earn-extra-view-all-button"
            target={'_self'}
            dataLocator={'accountverview-earnExtaPointTitle-viewallcta'}
            anchorVariation="button"
            buttonVariation="fixed-width"
            onClick={closedOverlay}
          >
            {'Earn Extra Points'}
          </Anchor>
        </BodyCopy>
        {selectedActivity && (
          <ExtraPointsDetailModal
            openState
            waysToEarnRow={selectedActivity}
            onRequestClose={onViewActivityDetails}
            closedOverlay={closedOverlay}
          />
        )}
      </div>
    )
  );
};
EarnExtraPointsTileNew.propTypes = {
  className: PropTypes.string,
  waysToEarn: PropTypes.shape([]),
  isFetching: PropTypes.bool,
  closedOverlay: PropTypes.func,
};
EarnExtraPointsTileNew.defaultProps = {
  className: '',
  waysToEarn: [],
  isFetching: false,
  closedOverlay: () => {},
};
export default withStyles(EarnExtraPointsTileNew, styles);
export { EarnExtraPointsTileNew as EarnExtraPointsTileNewVanilla };
